import React, { useRef } from 'react';
import { Typography, List, ListItem } from '@mui/material';
import * as S from './Styled';
import Cupom from '../Modal/Cupom/Cupom';
import useCouponRedirect from '../../hooks/useCouponRedirect';
import useUTMParams from '../../hooks/useUTMParams';
import useUserData from '../../hooks/useUserData';
import { useAlert } from '../../context/AlertContext';
import CouponCard, { getCashbackPercentage } from './CouponCard';
import { useTopCouponsRoute } from '../../hooks/useTopCouponRoute';

const CouponsList = ({ coupons = [], categorie = {}, pagination, }) => {
    const couponListRef = useRef(null);
    const { getcouponRedirect } = useCouponRedirect();
    const { utmSource, utmCampaign } = useUTMParams();
    const { user } = useUserData();
    const { showAlert } = useAlert();

    const { selectedCoupon, isModalOpen, openCoupon, closeCoupon } = useTopCouponsRoute(coupons);

    const scrollToCoupons = () => {
        couponListRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const renderedCoupons = (coupons || [])
        .filter((coupon) => coupon?.store)
        .map((coupon) => {
            const cat = coupon.hotArea || categorie || {};

            return (
                <CouponCard
                    key={coupon.id}
                    coupon={coupon}
                    categorie={cat}
                    uppercaseTitle
                    isAuthenticated={true}
                    openCoupon={openCoupon}
                    getcouponRedirect={getcouponRedirect}
                    utmSource={utmSource}
                    utmCampaign={utmCampaign}
                    userId={user?.id}
                    incentiveId={cat.incentive_id}
                    showAlert={showAlert}
                />
            );
        });

    return (
        <S.ContainerHowToUse>
        <S.CouponList ref={couponListRef}>
            {renderedCoupons.length ? renderedCoupons : <Typography>Nenhum cupom encontrado.</Typography>}
            {pagination && React.cloneElement(pagination, { onPageChange: scrollToCoupons })}
        </S.CouponList>

        <S.HowToUseSection>
            <h2>COMO USAR UM CUPOM:</h2>
            <Typography sx={{ fontSize: '14px' }}>
            É bem fácil usar um cupom de desconto através do MeuCupom.com e nós vamos te explicar!
            </Typography>
            <List component="ol">
            {[
                'Achou um bom cupom de desconto? Clique em “Pegar Cupom”. Ao clicar, uma janela será aberta.',
                'Dentro da janela, clique no botão “Copiar código e ir para a loja”...',
                'Procure o campo de cupons/vale e cole o código no carrinho.',
                'O desconto será reduzido automaticamente.',
            ].map((text, idx) => (
                <ListItem key={idx} sx={{ paddingLeft: 0 }}>
                <Typography sx={{ fontSize: '14px' }}>
                    <strong>{idx + 1}.</strong> {text}
                </Typography>
                </ListItem>
            ))}
            </List>
        </S.HowToUseSection>

        {isModalOpen && selectedCoupon && (
            <Cupom
            open={isModalOpen}
            handleClose={closeCoupon}
            couponId={selectedCoupon.id}
            name={selectedCoupon.name}
            slug={selectedCoupon.slug}
            cupomLink={selectedCoupon.linkUrl}
            cupomCode={selectedCoupon.code}
            description={selectedCoupon.description}
            clicks={selectedCoupon.clicks}
            endDate={selectedCoupon.endDate}
            storeName={selectedCoupon.store?.name}
            storeSlug={selectedCoupon.store?.slug}
            cashback={getCashbackPercentage(selectedCoupon.store, categorie)}
            incentiveId={categorie?.incentive_id}
            userId={user?.id}
            />
        )}
        </S.ContainerHowToUse>
    );
};

export default CouponsList;
